<template>
  <div class="panel panel-default tw-mb-0">
    <div class="panel-body">
      <h3 class="tw-mt-2 tw-mb-4">
        {{ publication.attributes.theme }}
      </h3>

      <p class="tw-whitespace-pre-line tw-mb-0">{{ publication.attributes.theme_description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    publication: {
      required: true
    }
  }
}
</script>
